import { DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SocialGroupMembers } from '../../search-component/invite-to-social-group/social-group.interface';
import { SearchResultsComponent } from '../basic-search-results/search-results.component';

@Component({
  selector: 'app-search-results-invite',
  templateUrl: './invite-search-results.component.html',
  styleUrls: ['../search-results-shared/search-results-shared.component.scss'],
  providers: [DecimalPipe],
})
export class SearchResultsInviteComponent extends SearchResultsComponent {
  @Input({ required: true }) public isSocialGroupLeader: boolean;
  @Input({ required: true }) public socialGroupProfileIds: SocialGroupMembers;

  public evaluateActionDisabled(user_id: string): boolean {
    const isVerified = this.socialGroupProfileIds.memberIds.has(user_id);
    const isInvitePending = this.socialGroupProfileIds.pendingMemberIds.has(user_id);

    if (isVerified || isInvitePending) {
      return true;
    }

    const isRequestPending = this.socialGroupProfileIds.pendingJoinRequests.has(user_id);

    if (isRequestPending && !this.isSocialGroupLeader) {
      return true;
    }

    return false;
  }

  public evaluateActionBtnHint(user_id: string): string {
    const isVerified = this.socialGroupProfileIds.memberIds.has(user_id);
    const isInvitePending = this.socialGroupProfileIds.pendingMemberIds.has(user_id);
    const isRequestPending = this.socialGroupProfileIds.pendingJoinRequests.has(user_id);

    if (isVerified || isInvitePending) {
      return 'BTN_INVITED_HINT';
    }

    if (isRequestPending && this.isSocialGroupLeader) {
      return 'BTN_ACCEPT_HINT';
    }

    return 'BTN_INVITE_HINT';
  }
}
